import React, { Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './contexts/AuthContext';
import { ContentProvider } from './contexts/ContentContext';
import PrivateRoute from './components/PrivateRoute';
import CookieConsent from './components/CookieConsent';
import Home from './pages/Home';
import About from './pages/About';
import ContactPage from './pages/ContactPage';
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import './i18n/i18n';

const Loading = () => (
  <div style={{
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#1e3a5f',
    color: '#ffffff',
    fontFamily: 'Inter, sans-serif',
    fontSize: '1.5rem',
    letterSpacing: '0.2em',
  }}>
    ZEL
  </div>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <ContentProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Suspense fallback={<Loading />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact-us" element={<ContactPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/en" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route
                  path="/admin"
                  element={
                    <PrivateRoute>
                      <Dashboard />
                    </PrivateRoute>
                  }
                />
              </Routes>
            </Suspense>
            <CookieConsent />
            <ToastContainer
              position="bottom-right"
              autoClose={3500}
              hideProgressBar={false}
              theme="dark"
            />
          </BrowserRouter>
        </ContentProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
